import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "courses";

export type courseType = {
  courses_no: string;
  courses_name: string;
  credits: number | null;
  status: string;
};

export type courseListType = {
  page?: number;
  limit?: number;
  keyword?: string;
  status?: string;
}

export class CourseApi extends BaseAPI {
  static list(query: courseListType): Promise<any> {
    return this.api.get(`${path}`, { params: { ...query } });
  }
  static create(body: courseType): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static updateOne(id_courses: number, body: courseType): Promise<any> {
    return this.api.patch(`${path}/${id_courses}`, body);
  }
  static findOne(id_courses: number): Promise<any> {
    return this.api.get(`${path}/${id_courses}`);
  }
  static updateStatus(id_courses: number, body: { status: string }): Promise<any> {
    return this.api.patch(`${path}/update_status/${id_courses}`, body);
  }

  static listDropdown(): Promise<AxiosResponse> {
    return this.api.get(`${path}/dropdown`)
  }
}
